
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"en":{"details":"Details","minutes":"{{minutes}} min"},"de":{"details":"Details","minutes":"{{minutes}} min"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();